import React, { useState } from 'react';
import { Box, Paper, Typography } from '@mui/material';
import AceEditor from 'react-ace';

import 'ace-builds/src-noconflict/mode-javascript';
import 'ace-builds/src-noconflict/mode-html';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-monokai';
import 'ace-builds/src-noconflict/theme-github';
import 'ace-builds/src-noconflict/ext-language_tools';

const CodeEditor = ({ code, onChange, language = 'javascript', readOnly = false, height = '400px' }) => {
  const [editorTheme, setEditorTheme] = useState('monokai');
  
  const handleChange = (newValue) => {
    if (onChange) {
      onChange(newValue);
    }
  };
  
  return (
    <Box sx={{ width: '100%', mb: 2 }}>
      <Paper elevation={2} sx={{ p: 1 }}>
        <Typography variant="subtitle2" sx={{ mb: 1 }}>
          {language.charAt(0).toUpperCase() + language.slice(1)} Editor
        </Typography>
        
        <AceEditor
          mode={language}
          theme={editorTheme}
          onChange={handleChange}
          value={code || ''}
          name="automation-code-editor"
          editorProps={{ $blockScrolling: true }}
          setOptions={{
            enableBasicAutocompletion: true,
            enableLiveAutocompletion: true,
            enableSnippets: true,
            showLineNumbers: true,
            tabSize: 2,
          }}
          width="100%"
          height={height}
          readOnly={readOnly}
          fontSize={14}
        />
      </Paper>
    </Box>
  );
};

export default CodeEditor;
